import type { Action, ThunkAction } from "@reduxjs/toolkit";
import { combineReducers, configureStore } from "@reduxjs/toolkit";

import { api } from "./apiSlice";
import errorReducer from "./errorSlice";
import errorMiddleware from "./errorSlice/middleware";
import mondayReducer from "./mondaySlice";

// import userSlice from './globalSlices/userSlice';

const reducer = combineReducers({
  [api.reducerPath]: api.reducer,
  monday: mondayReducer,
  errors: errorReducer,
});

export const store = configureStore({
  reducer,
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat([api.middleware, errorMiddleware]),
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof reducer>;
export type AppThunk<ReturnType = void> = ThunkAction<ReturnType, RootState, unknown, Action<string>>;
